import { lazy } from 'react';

export const MainPage = lazy(() =>
  import('./ui/MainPage').then((module) => ({
    default: module.MainPage,
  }))
);
